import Vue from "vue";
import VSelect from "vue-select";
import "vue-select/src/scss/vue-select.scss";

Vue.component("VSelect", VSelect);